import fr from './fr';
import en from './en';

export default { en: en, fr: fr };
